import { c as _c } from "react/compiler-runtime";
import { getFieldErrorsFromContext } from '@onefootprint/core';
import { useRequestError } from '@onefootprint/fetch-hosted/use-request-error';
import { type FieldError, useRequestErrorToast } from '@onefootprint/hooks';
import { isOnboardingSuperseded } from '@/idv2/utils/is-onboarding-superseded';
import { getLogger } from '@/idv2/utils/logger';
export type { FieldError };

/**
 * Formats field errors for logging (e.g. "key1: msg1; key2: msg2").
 */
export const formatFieldErrorsForLog = (fieldErrors: FieldError[]): string => fieldErrors.map(e => `${e.key}: ${e.message}`).join('; ');
const {
  logWarn
} = getLogger({
  name: 'idv2',
  location: 'vault-mutation-error'
});
export const useVaultMutationError = () => {
  const $ = _c(3);
  const showRequestErrorToast = useRequestErrorToast();
  const {
    getErrorContext
  } = useRequestError();
  let t0;
  if ($[0] !== getErrorContext || $[1] !== showRequestErrorToast) {
    t0 = (error, onFieldError) => {
      if (isOnboardingSuperseded(error)) {
        return [];
      }
      const context = getErrorContext(error);
      const fieldErrors = getFieldErrorsFromContext(context);
      if (fieldErrors.length > 0) {
        logWarn("Vault mutation field errors", error, {
          fieldErrors: formatFieldErrorsForLog(fieldErrors)
        });
      }
      showRequestErrorToast(error, fieldErrors);
      if (fieldErrors.length > 0 && onFieldError) {
        onFieldError(fieldErrors);
      }
      return fieldErrors;
    };
    $[0] = getErrorContext;
    $[1] = showRequestErrorToast;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleError = t0;
  return handleError;
};